import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, Input, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { GoalPeriodStatus } from 'src/app/enums/goal-period-status.enum';
import { IdName } from 'src/app/models/general/id-name.model';
import { GoalService } from 'src/app/services';

@UntilDestroy()
@Component({
  selector: 'app-goal-period-status-stepper',
  templateUrl: './goal-period-status-stepper.component.html',
  styleUrl: './goal-period-status-stepper.component.scss'
})
export class GoalPeriodStatusStepperComponent implements OnInit {
  
  public orientation: 'horizontal' | 'vertical' = 'horizontal';

  @Input() status: number;

  public steps: IdName[];
  
  constructor(private breakpointObserver: BreakpointObserver, private goalService: GoalService) {}

  ngOnInit(): void {
    this.steps = this.goalService.getGoalStatusList();
    //this.breakpointObserver.observe(['(max-width: 599px)']).subscribe(result => {
    this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small])
    .pipe(untilDestroyed(this))
    .subscribe(result => {
        this.orientation = result.matches ? 'vertical' : 'horizontal' 
    });
  }

  public currentIndex(): number {
    if (!this.status) return 0;

    const index = this.steps.findIndex(item => item.id === this.status);

    return index;
  }

  public getCompleted(index: number): boolean {
    if (this.status != GoalPeriodStatus.Approved) 
      return index < this.currentIndex();
    else
      return true;
  }

  public isActiveStep(index: number): boolean {
    return index === this.currentIndex();
  }
}
